console.log('From node component!!!');